module.exports = __webpack_public_path__ + "static/media/alchohol.a7a593ca.jpg";